module.exports = __webpack_public_path__ + "img/accessory_shirt_05.9771e6a0.svg";